/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServiceContactType } from './ServiceContactType';
import {
	ServiceContactTypeFromJSON,
	ServiceContactTypeFromJSONTyped,
	ServiceContactTypeToJSON,
} from './ServiceContactType';
import type { ServiceTeamSummary } from './ServiceTeamSummary';
import {
	ServiceTeamSummaryFromJSON,
	ServiceTeamSummaryFromJSONTyped,
	ServiceTeamSummaryToJSON,
} from './ServiceTeamSummary';
import type { UserProfileDetails } from './UserProfileDetails';
import {
	UserProfileDetailsFromJSON,
	UserProfileDetailsFromJSONTyped,
	UserProfileDetailsToJSON,
} from './UserProfileDetails';

/**
 *
 * @export
 * @interface ServiceContactWithDetails
 */
export interface ServiceContactWithDetails {
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof ServiceContactWithDetails
	 */
	rID: string;
	/**
	 *
	 * @type {Date}
	 * @memberof ServiceContactWithDetails
	 */
	createdAtUtc: Date;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof ServiceContactWithDetails
	 */
	createdByUserRID: string;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof ServiceContactWithDetails
	 */
	clientRID: string;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof ServiceContactWithDetails
	 */
	actorRID: string;
	/**
	 *
	 * @type {ServiceContactType}
	 * @memberof ServiceContactWithDetails
	 */
	contactType?: ServiceContactType;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof ServiceContactWithDetails
	 */
	metadataSchemaRID?: string;
	/**
	 *
	 * @type {object}
	 * @memberof ServiceContactWithDetails
	 */
	metadata?: object;
	/**
	 *
	 * @type {UserProfileDetails}
	 * @memberof ServiceContactWithDetails
	 */
	details?: UserProfileDetails;
	/**
	 *
	 * @type {ServiceTeamSummary}
	 * @memberof ServiceContactWithDetails
	 */
	serviceTeamDetails?: ServiceTeamSummary;
}

/**
 * Check if a given object implements the ServiceContactWithDetails interface.
 */
export function instanceOfServiceContactWithDetails(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'rID' in value;
	isInstance = isInstance && 'createdAtUtc' in value;
	isInstance = isInstance && 'createdByUserRID' in value;
	isInstance = isInstance && 'clientRID' in value;
	isInstance = isInstance && 'actorRID' in value;

	return isInstance;
}

export function ServiceContactWithDetailsFromJSON(json: any): ServiceContactWithDetails {
	return ServiceContactWithDetailsFromJSONTyped(json, false);
}

export function ServiceContactWithDetailsFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ServiceContactWithDetails {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		rID: json['RID'],
		createdAtUtc: new Date(json['createdAtUtc']),
		createdByUserRID: json['createdByUserRID'],
		clientRID: json['clientRID'],
		actorRID: json['actorRID'],
		contactType: !exists(json, 'contactType')
			? undefined
			: ServiceContactTypeFromJSON(json['contactType']),
		metadataSchemaRID: !exists(json, 'metadataSchemaRID')
			? undefined
			: json['metadataSchemaRID'],
		metadata: !exists(json, 'metadata') ? undefined : json['metadata'],
		details: !exists(json, 'details')
			? undefined
			: UserProfileDetailsFromJSON(json['details']),
		serviceTeamDetails: !exists(json, 'serviceTeamDetails')
			? undefined
			: ServiceTeamSummaryFromJSON(json['serviceTeamDetails']),
	};
}

export function ServiceContactWithDetailsToJSON(
	value?: ServiceContactWithDetails | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		RID: value.rID,
		createdAtUtc: value.createdAtUtc.toISOString(),
		createdByUserRID: value.createdByUserRID,
		clientRID: value.clientRID,
		actorRID: value.actorRID,
		contactType: ServiceContactTypeToJSON(value.contactType),
		metadataSchemaRID: value.metadataSchemaRID,
		metadata: value.metadata,
		details: UserProfileDetailsToJSON(value.details),
		serviceTeamDetails: ServiceTeamSummaryToJSON(value.serviceTeamDetails),
	};
}
